import React from "react";
import { Row } from "react-bootstrap";
import "../../Assets/Styles/pages/landing.scss";
import { useTranslation } from "react-i18next";

const TilesRow = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Row className="width75 text-black py-4 my-3 d-flex justify-content-center">
      {data &&
        data?.map((feature, i) => {
          let description = t(feature.description);

          return (
            <Row
              key={i}
              className="FeatureTile m-4 p-1 d-flex justify-content-center rounded_tiles"
            >
              <Row className="d-flex justify-content-center align-items-center m-0 p-0 py-5 px-4">
                <img
                  className="size_Tiles m-0 mb-2 p-0"
                  src={feature.img}
                  alt="Feature title"
                />
                <Row className="d-flex m-0 pt-1 line_height_1_364 pb-1 productSansBold text_18 justify-content-center alig-items-center">
                  {t(feature.title)}
                </Row>
                <Row className="d-flex m-0 pt-2 px-1 text-black line_height_1_406 productSansLight w-100 p-0 text_15 text-center justify-content-center ">
                  <p className="p-0">
                    {t(description)
                      .split("/n")
                      ?.map((line, index) => {
                        return (
                          <React.Fragment key={index}>
                            {line}
                            <br />
                          </React.Fragment>
                        );
                      })}
                  </p>
                </Row>
              </Row>
            </Row>
          );
        })}
    </Row>
  );
};

export default TilesRow;
